module.exports = __webpack_public_path__ + "static/media/ic_male.5edb7e60.png";